module.exports = __webpack_public_path__ + "static/media/loginbg-d.c618d851.jpg";